enum PluralCategory {
  CATEGORY_1,
  CATEGORY_2,
  CATEGORY_3,
  CATEGORY_4,
}

type PluralRule = (choice: number, choicesLength: number) => PluralCategory

const FrenchPluralRule: PluralRule = (choice) =>
  choice <= 1 ? PluralCategory.CATEGORY_1 : PluralCategory.CATEGORY_2

// We are missing decimal fractions here for polish pluralisation
const SlavicPluralRule: PluralRule = (choice, choicesLength) => {
  const endsWithOne = choice % 10 === 1
  const tenToTwenty = choice > 10 && choice < 20

  if (choicesLength === 3 && !tenToTwenty && endsWithOne) {
    return PluralCategory.CATEGORY_1
  } else if (choice === 1) {
    return PluralCategory.CATEGORY_1
  }

  if (choice % 10 >= 2 && choice % 10 <= 4 && !tenToTwenty) {
    return PluralCategory.CATEGORY_2
  }

  return PluralCategory.CATEGORY_3
}

const RomanianPluralRule: PluralRule = (choice) => {
  if (choice === 1) {
    return PluralCategory.CATEGORY_1
  }

  const lastTwoDigits = choice % 100
  const lastTwoDigitsToTwenty = lastTwoDigits >= 1 && lastTwoDigits < 20

  if (choice === 0 || lastTwoDigitsToTwenty) {
    return PluralCategory.CATEGORY_2
  }

  return PluralCategory.CATEGORY_3
}

const SlovenianPluralRule: PluralRule = (choice) => {
  const endsInZeroOne = choice % 100 === 1
  const endsWithZeroTwo = choice % 100 === 2
  const endsWithZeroThreeOrZeroFour = choice % 100 === 3 || choice % 100 === 4

  if (endsInZeroOne) {
    return PluralCategory.CATEGORY_1
  }

  if (endsWithZeroTwo) {
    return PluralCategory.CATEGORY_2
  }

  if (endsWithZeroThreeOrZeroFour) {
    return PluralCategory.CATEGORY_3
  }

  return PluralCategory.CATEGORY_4
}

export const PluralizationRulesMap = new Map<string, PluralRule>([
  ['fr', FrenchPluralRule],
  ['hy', FrenchPluralRule],
  ['bs', SlavicPluralRule],
  ['hr', SlavicPluralRule],
  ['sr', SlavicPluralRule],
  ['uk', SlavicPluralRule],
  ['ru', SlavicPluralRule],
  ['pl', SlavicPluralRule],
  ['ro', RomanianPluralRule],
  ['sl', SlovenianPluralRule],
])
